<template>
    <div class="usdt_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.push('/user')"></div>
            <div class="big_tit">{{$t('cash.withdraw')}}</div>
			<div class="top_right" @click="$router.push('/cashlist')">
				<van-icon name="bars" size="25"/>
			</div>
        </div>
       <div class="grid-wrap">
		   <a class="grid-item" @click="$router.push('/cash')">
               <div class="link-body"><h3 class="link-title">{{$t('d.c2bank')}}</h3></div>
               <!-- <div class="link-foot">{{$t('income.jichud')}}</div> -->
           </a>
		   <a class="grid-item" @click="$router.push('/cash2')">
               <div class="link-body"><h3 class="link-title">{{$t('d.c2usdt')}}</h3></div>
               <!-- <div class="link-foot">{{$t('income.tuid')}}</div> -->
           </a>
       </div>
    </div>
</template>

<script>
	import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import bsHeader from '../../components/bsHeader.vue'
	import Clipboard from 'v-clipboard';
	import {
		Icon
	} from 'vant';
	Vue.use(Clipboard).use(Icon);
    export default {
        name: "pay",
        data() {
            return {
                data: null,
                money: 0,
            };
        },
        created() {
            this.$parent.footer('user', true);
        },
        mounted() {
        },
        methods: {
           
        }
    };
</script>

<style lang="less" scoped>
	.grid-wrap {
	    display: grid;
		margin: 10px;
	}
	.link-body {
	    height: 100px;
	    background: no-repeat center/100% 100%;
	    padding-top: 20px;
	    padding-left: 20px;
	}
	.grid-item:first-child .link-body {
	    color: #434f70;
	    background-image: url(../images/index/deposit.png)
	}
	
	.grid-item:last-child .link-body {
	    color: #794a4a;
	    background-image: url(../images/index/depositright.png)
	}
	
	.link-foot {
	    padding: 15px;
	    line-height: 18px;
	    color: #6d6d6d;
	}
	.link-title {
	    margin: 0 0 8px;
	    font-size: 16px;
	}
	
	.grid-item {
	    overflow: hidden;
	    display: block;
	    position: relative;
	    margin-bottom: 20px;
	    background-color: #fff;
	    box-shadow: 0 0 4px 0 #dedede;
	    border-radius: 20px;
	}
</style>
